// Shared formatting helpers for timestamped dev-UI rows (prime, briefing, system log).

export function formatRelative(isoTime: string): string {
  const diff = Date.now() - new Date(isoTime).getTime();
  const abs = Math.abs(diff);
  const sign = diff >= 0 ? "ago" : "from now";
  const s = Math.round(abs / 1000);
  if (s < 60) return `${s}s ${sign}`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m ${sign}`;
  const h = Math.round(m / 60);
  if (h < 48) return `${h}h ${sign}`;
  const d = Math.round(h / 24);
  return `${d}d ${sign}`;
}

export function formatLocal(isoTime: string): string {
  return new Date(isoTime).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function shortSession(id: string | null): string {
  if (!id) return "—";
  return id.length > 10 ? `${id.slice(0, 8)}…` : id;
}
